import { typesTranslate, subTypesTranslate } from "./MovementEntity";

export const columns = [{
    field: 'idMovement',
    header: 'Id movimiento',
    sizes: { xs: 1 }
},
{
    field: 'warehouseName',
    header: 'Depósito',
    sizes: { xs: 2 }
},
{
    field: 'type',
    translate: ( value ) => typesTranslate[value],
    header: 'Tipo',
    sizes: { xs: 1 }
},
{
    field: 'subType',
    translate: ( value ) => subTypesTranslate[value],
    header: 'Subtipo',
    sizes: { xs: 2 }
},
{
    field: 'reason',
    header: 'Motivo',
    sizes: { xs: 2 }
},
{
    field: 'quantity',
    header: 'Cantidad',
    align:'center',
    sizes: { xs: 1 }
},
{
    field: 'date',
    header: 'Fecha',
    align:'center',
    type: 'date',
    sizes: { xs: 2 }
}];

export const title = "Historial de producto";